
<div class="card-content profile-eduction " *ngIf="ShowList">
  <div class="panel-heading">
    <div class="row">
      <div class="col-12">
        <!--<h6 class="panel-title fb">Education Info</h6>-->
        <div class="table-component">
          <div class="table-responsive">
            <table class="table  profile-table">
              <thead class="profile-thead ">
                <tr >
                  <th scope="col">Institute Type</th>
                  <th scope="col"> Name</th>
                  <th scope="col">Course Studied</th>
                  <th scope="col">Graduated</th>
                  <th scope="col">Completed Year</th>
                  <th scope="col">Action</th>

                </tr>
              </thead>
              <tbody>
                <tr  *ngFor="let l of CurrentActorEducationInfoController">
                  <td>{{l.InstituteType}}</td>
                  <td>{{l.InstituteName}}</td>
                  <td>{{l.CourseStudy}}</td>
                  <td>
                    <!--{{l.IsGraduate}}-->
                    <div *ngIf="l.IsGraduate">
                      <!--<input type="checkbox" checked data-toggle="toggle" data-onstyle="success" disabled>-->
                      <!--<div class="toggle-group"><label class="btn btn-success toggle-on">Yes</label></div>-->
                      <span class="tick-circle"><i class="fas fa-check"></i></span>
                    </div>
                    <div *ngIf="!l.IsGraduate">
                      <!--<input type="checkbox" data-toggle="toggle" data-onstyle="success" disabled>-->
                      <!--<div class="toggle-group"><label class="btn btn-success toggle-on">No</label></div>-->
                      <!--<span class="tick-circle"><i class="fas fa-check"></i></span>-->
                    </div>
                  </td>
                  <td>{{l.CompletedAt | date:'MMM-dd-yyyy'}}</td>
                
                  <td>
                    <div class="row">
                      <a (click)="edit_(l)" class="nav-link-hand education-navlink" *ngIf="CanEdit === 1 ">
                        <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                      </a>
                      <a (click)="del_(l.EducationCode)" class="nav-link-hand education-navlink" *ngIf="CanEdit === 1 ">
                        <span class="badge"><i class="far fa-trash-alt"></i>
                        </span>
                      </a>
                      <a (click)="openDocContent(l.ActorDocCode)" class="nav-link-hand education-navlink">
                        <span class="badge">
                          <!--<i class="fa fa-file grey"></i>--><i class="fas fa-paperclip"></i>
                          </span>
                      </a>
                    </div>
                  </td>
               </tr>
              
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>

    <!--<div class="row">
      <div class="col-md-12 col-xs-12 mt-2 mb-4 text-right add-but">
        <button type="button" (click)="ExpandData()" class="btn btn-primary btn-sm"><i class="fas round-plus"></i>Expand</button>
      </div>
    </div>-->
    <div *ngIf='IsExpand'>
      <div class="row" *ngIf="ShowList">
        <div class="col-md-12 col-xs-12 mt-2 mb-4 text-right add-but addnew">
          <button type="button" (click)="clearData()" class="btn btn-primary btn-sm"><!--<i class="fas fa-plus nav-link-hand"> </i>--> Add New</button>
        </div>
      </div>
      <div *ngIf='isNew && !ShowList'>
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">

          <div class="comon-box profile-box p-0">
            <h4 class="heading-pinkbg mt-0">Add Education</h4>
            <div class="row pl-3 pr-3 margin-left-zero">


              <div class="form-group col-md-6 col-xs-12">
                <label for="eventInput2">Institute Type</label>
                <CodeTypeValue CodeType="INSTY" id="CurrentActorEducationInfoRequest.InstituteType"
                               [(ngModel)]="CurrentActorEducationInfoRequest.InstituteType" SelectedValue=""
                               name="CurrentActorEducationInfoRequest.InstituteType" #InstituteType="ngModel"></CodeTypeValue>

              </div>

              <div class="form-group col-md-6 col-xs-12">
                <label for="eventInput2"><span>*</span> Course Study  </label>
                <input type="text" class="form-control" id="CurrentActorEducationInfoRequest.CourseStudy"
                       [(ngModel)]="CurrentActorEducationInfoRequest.CourseStudy" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                       name="CurrentActorEducationInfoRequest.CourseStudy" placeholder="Course Study" required maxlength="100" minlength="1" #CourseStudy="ngModel">
                <small class="form-text text-danger"
                       *ngIf="(!CourseStudy.valid && (CourseStudy.dirty || CourseStudy.touched) && CourseStudy.errors.required)">(Field cannot be left blank)</small>

                <small class="form-text text-danger"
                       *ngIf="(!CourseStudy.valid && CourseStudy.errors.pattern)">(special characters are not allowed)</small>
              </div>

              <div class="form-group col-md-6 col-xs-12">
                <label for="eventInput2">Institute Name</label>
                <input type="text" class="form-control" id="CurrentActorEducationInfoRequest.InstituteName"
                       [(ngModel)]="CurrentActorEducationInfoRequest.InstituteName" name="CurrentActorEducationInfoRequest.InstituteName"
                       placeholder="InstituteName" pattern="^[\sa-zA-Z0-9,._\-?]*$" #InstituteName="ngModel" maxlength="100">
                <small class="form-text text-danger"
                       *ngIf="(!InstituteName.valid && InstituteName.errors.pattern)">(special characters are not allowed)</small>

              </div>

              <div class="form-group col-md-6 col-xs-12">
                <label for="eventInput2">Location</label>
                <input type="text" class="form-control" id="CurrentActorEducationInfoRequest.Location"
                       [(ngModel)]="CurrentActorEducationInfoRequest.Location" pattern="^[\sa-zA-Z0-9,._\-?]*$" #Location="ngModel"
                       name="CurrentActorEducationInfoRequest.Location" placeholder="Location"
                       maxlength="100">
                <small class="form-text text-danger"
                       *ngIf="(!Location.valid && Location.errors.pattern)">(special characters are not allowed)</small>


              </div>



              <div class="form-group col-md-6 col-xs-12">
                <label for="eventInput4">Start From</label>

                <div class="date-form">
                  <input class="form-control" placeholder="Start From" [minDate]="minDate" [maxDate]="maxDate"
                         name="dp" [(ngModel)]="ValidFrom" ngbDatepicker #d="ngbDatepicker">

                  <a (click)="d.toggle()" class="nav-link-hand">
                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                  </a>

                </div>
              </div>


              <div class="form-group col-md-6 col-xs-12">
                <label for="eventInput5">Completed Date</label>
                <!--<div *ngIf="!CanAdjustgetTimezoneOffset">
      <input type="date" class="form-control" id="CurrentActorEducationInfoRequest.CompletedAt"
             [(ngModel)]="CurrentActorEducationInfoRequest.CompletedAt" name="CurrentActorEducationInfoRequest.CompletedAt"
             placeholder="CompletedAt">
    </div>-->
                <!--<div *ngIf="CanAdjustgetTimezoneOffset">
      <input [owlDateTimeTrigger]="CompletedAt" class="form-control" [owlDateTime]="CompletedAt"
             [max]="MaxDateV"
             id="CurrentActorEducationInfoRequest.CompletedAt"
             placeholder="Completed Date"
             [(ngModel)]="CurrentActorEducationInfoRequest.CompletedAt"
             name="CurrentActorEducationInfoRequest.CompletedAt">
      <owl-date-time [pickerType]="'calendar'" #CompletedAt></owl-date-time>
    </div>-->
                <div class="date-form">
                  <input class="form-control" placeholder="Completed Date " [minDate]="minDate" [maxDate]="maxDate"
                         name="dp1" [(ngModel)]="ValidTo" ngbDatepicker #d1="ngbDatepicker">

                  <a (click)="d1.toggle()" class="nav-link-hand">
                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                  </a>

                </div>
              </div>
              <div class="form-group col-md-6 col-xs-12">
                <label for="eventInput5">Graduate</label>
                <!--<input type="checkbox" class="form-control" id="CurrentActorEducationInfoRequest.IsGraduate"
    [(ngModel)]="CurrentActorEducationInfoRequest.IsGraduate" name="CurrentActorEducationInfoRequest.IsGraduate" placeholder="IsGraduate">-->


                <label class="radio-inline">

                  Yes  <input type="radio" [value]="true" class=""
                              id="CurrentActorEducationInfoRequest.IsGraduate"
                              [(ngModel)]="CurrentActorEducationInfoRequest.IsGraduate"
                              name="CurrentActorEducationInfoRequest.IsGraduate">
                </label>
                <label class="radio-inline">
                  No <input type="radio" [value]="false" class=""
                            id="CurrentActorEducationInfoRequest.IsGraduate"
                            [(ngModel)]="CurrentActorEducationInfoRequest.IsGraduate"
                            name="CurrentActorEducationInfoRequest.IsGraduate">
                </label>
                <!--<label class="radio-inline">
      Yes <input type="radio" id="CurrentActorEducationInfoRequest.IsGraduate" name="CurrentActorEducationInfoRequest.IsGraduate" [(ngModel)]="CurrentActorEducationInfoRequest.IsGraduate" value="true">
    </label>
    <label class="radio-inline">
      No <input type="radio" id="CurrentActorEducationInfoRequest.IsGraduate" name="CurrentActorEducationInfoRequest.IsGraduate" [(ngModel)]="CurrentActorEducationInfoRequest.IsGraduate" value="false">
    </label>-->

              </div>
              <div class="form-group col-md-6 col-xs-12">
                <label for="eventInput5">Remarks</label>
                <input type="text" class="form-control" id="CurrentActorEducationInfoRequest.Remarks" #Remarks="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                       [(ngModel)]="CurrentActorEducationInfoRequest.Remarks" name="CurrentActorEducationInfoRequest.Remarks" placeholder="Remarks" maxlength="250">
                <small class="form-text text-danger"
                       *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
              </div>

              <!--<div class="card-footer pink-bg text-right" *ngIf="CanEdit === 1 ">
    <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime">Save</button>

  </div>-->

              <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />

            </div>


          </div>
          
          <div class="row" *ngIf="CanEdit === 1 ">
            <div class="card-footer text-right col-12">
              <button type="button"
                      (click)="CancelNewOperation()" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3">Cancel</button>
              <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand">Save</button>




            </div>
          </div>

        </form>
      </div>
      <div *ngIf='isEdit && !ShowList'>
        <form class="form" novalidate="" (ngSubmit)="onEditSubmit()" #f="ngForm">

          <div class="comon-box p-0 margin-left-zero">
            <h4 class="heading-pinkbg mt-0">Update Education</h4>
            <div class="row pl-3 pr-3 margin-left-zero">




              <div class="form-group col-md-6 col-xs-12">
                <label for="eventInput2">Institute Type</label>
                <CodeTypeValue CodeType="INSTY" id="CurrentActorEditEducationInfoRequest.InstituteType"
                               [(ngModel)]="CurrentActorEditEducationInfoRequest.InstituteType"
                               name="CurrentActorEditEducationInfoRequest.InstituteType" SelectedValue="{{CurrentActorEditEducationInfoRequest.InstituteType}}"></CodeTypeValue>
              </div>

              <div class="form-group col-md-6 col-xs-12">
                <label for="eventInput2">Course Study  <span>*</span></label>
                <input type="text" class="form-control" id="CurrentActorEditEducationInfoRequest.CourseStudy"
                       [(ngModel)]="CurrentActorEditEducationInfoRequest.CourseStudy" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                       name="CurrentActorEditEducationInfoRequest.CourseStudy" placeholder="Course Study" required maxlength="100" minlength="1" #CourseStudy="ngModel">
                <small class="form-text text-danger"
                       *ngIf="(!CourseStudy.valid && (CourseStudy.dirty || CourseStudy.touched) && CourseStudy.errors.required)">(Field cannot be left blank)</small>
                <small class="form-text text-danger"
                       *ngIf="(!CourseStudy.valid && CourseStudy.errors.pattern)">(special characters are not allowed)</small>
              </div>

              <div class="form-group col-md-6 col-xs-12">
                <label for="eventInput2">Institute Name</label>
                <input type="text" class="form-control" id="CurrentActorEditEducationInfoRequest.InstituteName" pattern="^[\sa-zA-Z0-9,._\-?]*$" #InstituteName="ngModel"
                       [(ngModel)]="CurrentActorEditEducationInfoRequest.InstituteName" name="CurrentActorEditEducationInfoRequest.InstituteName"
                       placeholder="InstituteName" maxlength="100">
                <small class="form-text text-danger"
                       *ngIf="(!InstituteName.valid && InstituteName.errors.pattern)">(special characters are not allowed)</small>

              </div>

              <div class="form-group col-md-6 col-xs-12">
                <label for="eventInput2">Location</label>
                <input type="text" class="form-control" id="CurrentActorEditEducationInfoRequest.Location"
                       [(ngModel)]="CurrentActorEditEducationInfoRequest.Location"
                       name="CurrentActorEditEducationInfoRequest.Location" pattern="^[\sa-zA-Z0-9,._\-?]*$" #Location="ngModel"
                       placeholder="Location" maxlength="100">
                <small class="form-text text-danger"
                       *ngIf="(!Location.valid && Location.errors.pattern)">(special characters are not allowed)</small>

              </div>

              <!--<div class="form-group col-md-6 col-xs-12">
        <label for="eventInput4">Start From</label>
        <input #myDatePicker type="date" class="form-control"
               value='{{ CurrentActorEditEducationInfoRequest.StartFrom | date:"yyyy-MM-dd" }}'
               (input)="onInputValidFrom(myDatePicker.value)"
               placeholder="Star tFrom" />

      </div>-->
              <div class="form-group col-md-6 col-xs-12">
                <label for="eventInput4">Start From</label>
                <!--<div *ngIf="!CanAdjustgetTimezoneOffset">
    <input #myDatePicker type="date" class="form-control"
           value='{{ CurrentActorEditEducationInfoRequest.StartFrom | date:"yyyy-MM-dd" }}'
           (input)="onInputValidFrom(myDatePicker.value)"
           placeholder="Star tFrom" />
  </div>-->
                <!--<div *ngIf="CanAdjustgetTimezoneOffset">
    <input [owlDateTimeTrigger]="StartFrom" class="form-control" [owlDateTime]="StartFrom" [max]="MaxDateV"
           id="CurrentActorEditEducationInfoRequest.StartFrom" placeholder="Start From"
           [(ngModel)]="CurrentActorEditEducationInfoRequest.StartFrom" name="CurrentActorEditEducationInfoRequest.StartFrom">
    <owl-date-time [pickerType]="'calendar'" #StartFrom></owl-date-time>
  </div>-->
                <div class="date-form">
                  <input class="form-control" placeholder="Start From" [minDate]="minDate" [maxDate]="maxDate"
                         name="dp" [(ngModel)]="ValidFrom" ngbDatepicker #d="ngbDatepicker">
                  
                    <a  (click)="d.toggle()" class="nav-link-hand" >
                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      

                    </a>

                  </div>
                </div>

                <!--<div class="form-group col-md-6 col-xs-12">
    <label for="eventInput5">Completed At</label>
    <input #myDatePicker1 type="date" class="form-control"
           value='{{ CurrentActorEditEducationInfoRequest.CompletedAt | date:"yyyy-MM-dd" }}'
           (input)="onInputValidTo(myDatePicker1.value)"
           placeholder="CompletedAt" />

  </div>-->
              <div class="form-group col-md-6 col-xs-12">
                <label for="eventInput4">Completed Date</label>
                <!--<div *ngIf="!CanAdjustgetTimezoneOffset">
    <input #myDatePicker1 type="date" class="form-control"
           value='{{ CurrentActorEditEducationInfoRequest.CompletedAt | date:"yyyy-MM-dd" }}'
           (input)="onInputValidTo(myDatePicker1.value)"
           placeholder="CompletedAt" />
  </div>-->
                <!--<div *ngIf="CanAdjustgetTimezoneOffset">
    <input [owlDateTimeTrigger]="CompletedAt" class="form-control" [owlDateTime]="CompletedAt" [max]="MaxDateV"
           id="CurrentActorEditEducationInfoRequest.CompletedAt" placeholder="Completed Date"
           [(ngModel)]="CurrentActorEditEducationInfoRequest.CompletedAt" name="CurrentActorEditEducationInfoRequest.CompletedAt">
    <owl-date-time [pickerType]="'calendar'" #CompletedAt></owl-date-time>
  </div>-->
                <div class="date-form">
                  <input class="form-control" placeholder="Completed Date" [minDate]="minDate" [maxDate]="maxDate"
                         name="dp1" [(ngModel)]="ValidTo" ngbDatepicker #d1="ngbDatepicker">
                
                    <a  (click)="d1.toggle()" class="nav-link-hand" >
                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                    </a>

                  </div>
                </div>
              <div class="form-group col-md-6 col-xs-12">
                <label for="eventInput5">Graduate</label>
                <!--<input type="checkbox" class="form-control" id="CurrentActorEditEducationInfoRequest.IsGraduate"
  [(ngModel)]="CurrentActorEditEducationInfoRequest.IsGraduate" name="CurrentActorEditEducationInfoRequest.IsGraduate" placeholder="IsGraduate">-->

                <label class="radio-inline">

                  Yes  <input type="radio" [value]="true" class=""
                              id="CurrentActorEditEducationInfoRequest.IsGraduate"
                              [(ngModel)]="CurrentActorEditEducationInfoRequest.IsGraduate"
                              name="CurrentActorEditEducationInfoRequest.IsGraduate">
                </label>
                <label class="radio-inline">
                  No <input type="radio" [value]="false" class=""
                            id="CurrentActorEditEducationInfoRequest.IsGraduate"
                            [(ngModel)]="CurrentActorEditEducationInfoRequest.IsGraduate"
                            name="CurrentActorEditEducationInfoRequest.IsGraduate">
                </label>
              </div>
                <div class="form-group col-md-6 col-xs-12">
                  <label for="eventInput5">Remarks</label>
                  <input type="text" class="form-control" id="CurrentActorEditEducationInfoRequest.Remarks"
                         [(ngModel)]="CurrentActorEditEducationInfoRequest.Remarks"   #Remarks="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                         name="CurrentActorEditEducationInfoRequest.Remarks" placeholder="Remarks"  maxlength="100">
                   <small class="form-text text-danger"
             *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                </div>

                <!--<div class="card-footer pink-bg text-right" *ngIf="CanEdit === 1 ">
    <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime">Update</button>

  </div>-->
                <br /><br /><br /><br /><br /><br /><br /><br /><br /><br/><br /><br /><br />
              </div>


          </div>


          <div class="row" *ngIf="CanEdit === 1 ">
            <div class="card-footer text-right col-12">

              <button (click)="CancelUpdateOperation()" *ngIf='!isRequesting' class="btn button-Schedule actions-btn-prime nav-link-hand actions-btn-prime3">Cancel</button>
              <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand">Update</button>


            </div>
          </div>




        </form>
      </div>
    </div>


    <!--<div class="row">
      <div class="form-group col-md-12 col-xs-12 mt-5"><a href="#finish" role="menuitem" class="btn-blue-main">Save</a></div>
    </div>-->
